import { UserInfoModel } from '@/models/UserInfoModel';
export default class JwtService{
    parseJwt (token:string) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));   
        const json = JSON.parse(jsonPayload)
        let user_info: UserInfoModel = JSON.parse(json.name);
        return user_info;
    };
    filter(arr:any, term:any) {
        let matches = [] as any;
        if (!Array.isArray(arr)) return matches;
    
        arr.forEach((i) => {
            if (i.name.includes(term)) {
                matches.push(i);
            } else {
                let childResults = this.filter(i.children, term);
                if (childResults.length)
                    matches.push(Object.assign({}, i, { children: childResults }));
            }
        })
    
        return matches;
    }
}